const useToolBarSettingDisabled = ({
  dealsGroup,
  tradesGroup,
  dealsNotSentToPb,
  dealTradesGroup,
  tradesGiveUp,
  tradesConversion,
  dealsGiveUpGroup,
  unAllocatedDeals
}) => {
  const disabledGroupTrade = () => {
    if (
      Object.keys(tradesGroup).length >= 2 ||
      (Object.keys(dealsNotSentToPb).length === 1 && Object.keys(tradesGroup).length >= 1)
    ) {
      if (Object.keys(dealsNotSentToPb).length === 1 && Object.keys(tradesGroup).length >= 1) {
        const trade = Object.values(tradesGroup).find(trade => !trade.prime_broker_mapping)
        if (trade) {
          return true
        }
      }
      return false
    }
    return true
  }

  const disabledUnGroupDeal = () => {
    if (Object.keys(dealsNotSentToPb).length >= 0 && Object.keys(tradesGroup).length === 0)
      return false
    return true
  }

  const disabledAmendTrade = () => {
    if (
      Object.keys(tradesGroup).length +
        Object.keys(dealTradesGroup).length +
        Object.keys(tradesGiveUp).length +
        Object.keys(tradesConversion).length !==
      1
    )
      return true
    return false
  }

  const disabledDealGiveUp = () => {
    if (Object.keys(dealsGiveUpGroup).length === 0 && Object.keys(tradesGiveUp).length === 0)
      return true
    return false
  }

  const disabledDeleteTradeDeal = () => {
    if (
      Object.keys(dealsGroup).length > 0 ||
      Object.keys(tradesGroup).length > 0 ||
      Object.keys(tradesGiveUp).length > 0 ||
      Object.keys(tradesConversion).length > 0
    )
      return false
    return true
  }

  const disabledUnAllocatedDeal = () => {
    if (Object.keys(unAllocatedDeals).length === 0) {
      return true
    }
    const dealsValue = Object.values(unAllocatedDeals)
    const { base_currency, counter_currency, type } = dealsValue[0]
    const allDealsHaveSameAttributes = dealsValue.every(
      deal =>
        deal.base_currency === base_currency &&
        deal.counter_currency === counter_currency &&
        deal.type === type
    )
    if (!allDealsHaveSameAttributes) {
      return true
    }
    return false
  }

  return {
    disabledGroupTrade,
    disabledUnGroupDeal,
    disabledAmendTrade,
    disabledDealGiveUp,
    disabledDeleteTradeDeal,
    disabledUnAllocatedDeal
  }
}

export default useToolBarSettingDisabled
